import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "v-home" }

import Hero from '@/components/home/hero.vue'
import Features from '@/components/home/features.vue'
import Showcase from '@/components/home/showcase.vue'
import HomeFaq from '@/components/home/home-faq.vue'
import Pricing from '@/views/pricing.vue'
import { users } from '@/modules/users'
import { router } from '@/router'
import { onMounted, nextTick } from 'vue'
import { modal } from '@/components/main/modal'


export default /*#__PURE__*/_defineComponent({
  __name: 'home',
  setup(__props) {

if (users.is_logged_in()) {
  router.push('/dash')
}

onMounted(() => {
  nextTick(() => {
    if (users.is_logged_in()) {
      modal.close()
      router.push('/dash')
    }
  })
})


return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _createVNode(Hero),
    _createVNode(Features),
    _createVNode(Showcase),
    _createVNode(Pricing),
    _createVNode(HomeFaq),
    _createVNode(_component_router_view)
  ]))
}
}

})